module.exports = __webpack_public_path__ + "static/media/skincarepro_v1_9report.3807b0e4.png";